export default {
    searchBy: 'Search by Holiday Name',
    search: 'Search',
    addGroupHoliday: 'Create Group Holiday',
    groupHolidayName: 'Holiday Name',
    holiday: 'Holiday Date',
    dateCreate: 'Date Create',
    forGroup: 'For Group',
    description: 'Description',
    deleteGroup: 'Delete Group Holiday',
    congratulation: 'Congratulation',
    msgDeleteSuccess: 'Group Holiday is deleted.',
    questionDelete: 'Are you sure to delete "$Name" Holiday?',
    companyHoliday: 'Company Holiday'
}
